
import React, { useEffect, useState } from 'react';
import { Clock } from 'lucide-react';

interface CountdownTimerProps {
  targetDate: Date;
  label: string;
}

const CountdownTimer = ({ targetDate, label }: CountdownTimerProps) => {
  const [timeLeft, setTimeLeft] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      const difference = targetDate.getTime() - now.getTime();
      
      if (difference <= 0) {
        clearInterval(interval);
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
        return;
      }
      
      const days = Math.floor(difference / (1000 * 60 * 60 * 24));
      const hours = Math.floor((difference / (1000 * 60 * 60)) % 24);
      const minutes = Math.floor((difference / (1000 * 60)) % 60);
      const seconds = Math.floor((difference / 1000) % 60);
      
      setTimeLeft({ days, hours, minutes, seconds });
    }, 1000);
    
    return () => clearInterval(interval);
  }, [targetDate]);
  
  return (
    <div className="mt-6">
      <div className="text-center mb-2 flex items-center justify-center gap-2">
        <Clock className="h-5 w-5 text-amber-500" />
        <p className="font-medium text-gray-700">{label}</p>
      </div>
      
      <div className="grid grid-cols-4 gap-2 text-center">
        <div className="bg-gray-100 rounded-lg p-2">
          <div className="text-xl md:text-2xl font-bold text-brand-600">{timeLeft.days}</div>
          <div className="text-xs text-gray-500">Days</div>
        </div>
        <div className="bg-gray-100 rounded-lg p-2">
          <div className="text-xl md:text-2xl font-bold text-brand-600">{timeLeft.hours}</div>
          <div className="text-xs text-gray-500">Hours</div>
        </div>
        <div className="bg-gray-100 rounded-lg p-2">
          <div className="text-xl md:text-2xl font-bold text-brand-600">{timeLeft.minutes}</div>
          <div className="text-xs text-gray-500">Minutes</div>
        </div>
        <div className="bg-gray-100 rounded-lg p-2">
          <div className="text-xl md:text-2xl font-bold text-brand-600">{timeLeft.seconds}</div>
          <div className="text-xs text-gray-500">Seconds</div>
        </div>
      </div>
    </div>
  );
};

export default CountdownTimer;
